import {
  FIELD_AUDIENCES_KEY,
  FIELD_PRIVACY_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { TemplateKey } from "PFApp/constants/templates";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfirmationModals } from "../activity_form.types";
import { useActivityFormStore, useActivityFormStoreActions } from "../activity_form_store";

export const FormModals = () => {
  const { t: tActivities } = useTranslation("activities");
  const { t } = useTranslation("activities", { keyPrefix: "form.modals" });

  const { setValue } = useFormContext();

  const template = useActivityFormStore((state) => state.template);
  const modals = useActivityFormStore((state) => state.modals);
  const { setModalDisplayed, setModalConfirmed, setSubmitOptions } = useActivityFormStoreActions();

  return (
    <>
      {modals[ConfirmationModals.NoRequirements].isDisplayed && (
        <Modal
          title={t("noRequirements")}
          onOK={() => {
            setModalConfirmed(ConfirmationModals.NoRequirements, true);
          }}
          onClose={() => {
            setModalDisplayed(ConfirmationModals.NoRequirements, false);
            setSubmitOptions({});
          }}
        >
          <Typography variant="bodyRegular">
            {t("creatingNoRequirementsWarning", {
              templateName: tActivities(`templates.${template.key as TemplateKey}`)
            })}
          </Typography>
        </Modal>
      )}
      {modals[ConfirmationModals.Public].isDisplayed && (
        <Modal
          title={t("makePublic")}
          onOK={() => {
            setValue(FIELD_PRIVACY_KEY, false);
            setValue(FIELD_AUDIENCES_KEY, []);
            setModalConfirmed(ConfirmationModals.Public, true);
            setModalDisplayed(ConfirmationModals.Public, false);
          }}
          onClose={() => {
            setModalDisplayed(ConfirmationModals.Public, false);
          }}
        >
          <Typography variant="bodyRegular">{t("makingRolePublicWarning")}</Typography>
        </Modal>
      )}
      {modals[ConfirmationModals.QuestionsChanged].isDisplayed && (
        <Modal
          title={t("showInterestQuestions")}
          onOK={() => {
            setModalConfirmed(ConfirmationModals.QuestionsChanged, true);
          }}
          onClose={() => {
            setModalDisplayed(ConfirmationModals.QuestionsChanged, false);
            setModalConfirmed(ConfirmationModals.NoRequirements, false);
            setSubmitOptions({});
          }}
        >
          <Typography variant="bodyRegular">{t("changedQuestionsWarning")}</Typography>
        </Modal>
      )}
      {modals[ConfirmationModals.Misalignment].isDisplayed && (
        <Modal
          title={t("existingBooking")}
          onOK={() => {
            setModalConfirmed(ConfirmationModals.Misalignment, true);
          }}
          onClose={() => {
            setModalDisplayed(ConfirmationModals.Misalignment, false);
            setModalConfirmed(ConfirmationModals.NoRequirements, false);
            setModalConfirmed(ConfirmationModals.QuestionsChanged, false);
            setSubmitOptions({});
          }}
        >
          <Typography variant="bodyRegular">{t("potentialMisalignmentWarning")}</Typography>
        </Modal>
      )}
    </>
  );
};
